import { Combobox } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import type { KmAttrTypeChoice } from '@/entities/ontology';
import type { KmAttrFormValue } from './attrFormValue';

type Props = {
  /** Варианты встроенного справочника атрибута */
  choices: KmAttrTypeChoice[];
  /** Выбирается несколько значений сразу */
  isMulti?: boolean;
  value?: KmAttrFormValue;
  onChange?: (value: KmAttrFormValue) => void;
  disabled?: boolean;
  error?: string;
  placeholder?: string;
};

/**
 * Выбор значения из встроенного перечня вариантов атрибута: значение — код варианта,
 * подпись — его название.
 */
export const KmAttrChoiceInput: FC<Props> = ({ choices, isMulti, value, onChange, disabled, error, placeholder }) => {
  const options = useMemo(() => choices.map((choice) => ({ value: choice.code, label: choice.label })), [choices]);

  if (isMulti) {
    const selected = Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];

    return (
      <Combobox
        isMulti
        value={selected}
        onChange={(next) => onChange?.((Array.isArray(next) ? next : []).map(String))}
        options={options}
        disabled={disabled}
        error={error}
        placeholder={placeholder}
        className="w-full"
      />
    );
  }

  return (
    <Combobox
      value={typeof value === 'string' ? value : ''}
      onChange={(next) => onChange?.(next === undefined || next === null ? '' : String(next))}
      options={options}
      disabled={disabled}
      error={error}
      placeholder={placeholder}
      className="w-full"
    />
  );
};
